import { HttpHelper } from '../helpers/httpHelper';
import { UrlManager } from '../providers/urlManager/urlManager';
import { roleList } from './mockRoleList';
import { userList } from './mockUserLists';

export const employeeApi = {
    getEmployee: email => {
        return HttpHelper.fetch(UrlManager.getEmployeeUrl(), {
            method: 'GET',
            queryParams: { email },
        });
    },
    getEmployeeOverview: () => {
        return HttpHelper.fetch(UrlManager.getEmployeeOverviewUrl(), {
            method: 'GET',
        });
    },
    getUserData: empId => {
        return HttpHelper.fetch(UrlManager.getUserDataUrl(), {
            method: 'GET',
            queryParams: { emp_id: empId },
        });
    },

    getUserList: (mock = false) => {
        if (mock) return userList;
        return HttpHelper.fetch(UrlManager.getUserListtUrl(), {
            method: 'GET',
        });
    },
    getRoleList: (mock = false) => {
        if (mock) return roleList;
        return HttpHelper.fetch(UrlManager.getRoleListtUrl(), {
            method: 'GET',
        });
    },

    getEmployeeTimeOff: userid => {
        return HttpHelper.fetch(UrlManager.getEmployeeTimeOffUrl(), {
            method: 'POST',
            body: { user_id: userid },
        });
    },

    updateUserRole: (roleId, userId) => {
        return HttpHelper.fetch(UrlManager.updateUserRoleUrl(), {
            method: 'POST',
            body: { role: roleId, id: userId },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
    },
};
